import { FC, useMemo, useState } from 'react';
import styles from './Item.module.scss';
import useMassActions from './MassAction/useMassActions';
import classnames from 'classnames';
import CheckIcon from '@static/img/icons/check.svg';

const ItemMassActionHandler: FC<{ orderType: string; orderNo: string }> = ({ orderType, orderNo }) => {
    const [isToggle, setToggle] = useState<boolean>(false);
    const { toggle, allowedType } = useMassActions();
    const isDisabled = useMemo(() => allowedType != null && allowedType != orderType, [allowedType, orderType]);
    return (
        <div className={classnames("form-check", styles.mass_handler)}>
            <input
                className="form-check-input"
                type="checkbox"
                id={`mass-action-handler-${orderNo}`}
                disabled={isDisabled}
            // checked={field.value}
            />
            <div className={classnames(styles.checkbox, {
                [styles.checked]: isToggle,
                [styles.disabled]: isDisabled,
            })} onClick={(e) => {
                e.preventDefault();
                if (isDisabled) return;
                toggle(orderType, orderNo)
                setToggle(_isToggle => !_isToggle);
            }}>
                {isToggle && <CheckIcon />}</div>
        </div>
    );
};

export default ItemMassActionHandler;
